/****************************************************
 * Module Name:  sideIncMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import logo from '../../images/pansuriya.jpg'
import { Modal, Form } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import Constants from "../../utility/constants";
import SaveIcon from '@mui/icons-material/Save';
import Utility from "../../utility/utility";
import SideIncProxy from "../../utility/proxy/manager/sideIncProxy";
// import CommonSnackbar from "../common/commonSnackBar";

const AddSideIncModal = ({
    handleSave,
    handleClose,
    editOperation,
    sourceData,
    loader
}) => {

    const [newSideInc, setNewSideInc] = useState(editOperation ? sourceData.name : "");
    const [newSideIncFullname, setNewSideIncFullname] = useState(editOperation ? sourceData.fullname : "");
    const [newSeq, setNewSeq] = useState(editOperation ? sourceData.seq : "");

    const [sideIncLoader, setSideIncLoader] = useState(false);
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const [sideIncAvailable, setSideIncAvailable] = useState(true);

    const [sideIncValidationError, setSideIncValidationError] = useState("");
    const [fullNameValidationError, setFullNameValidationError] = useState("");

    const addEditSideInc = () => {
        let data = {
            id: editOperation ? sourceData.id : undefined,
            name: newSideInc,
            fullname: newSideIncFullname,
            seq: newSeq
        };

        if (handleSave) {
            handleSave(data);
        }
    };

    const validateSideIncPresent = (sideIncEntered) => {
        if (!sideIncEntered || sideIncEntered.trim() === "") return;

        setSideIncLoader(true);
        SideIncProxy.CheckSideIncAvailable(sideIncEntered, (response) => {
            // If we got response that means side inc is present at backend
            if (response) {
                // Side Inc Name already present
                setSideIncLoader(false);
                setShowValidationMessage(true);
                setSideIncAvailable(false);
            } else {
                // Side Inc Name not available, so can be used
                setSideIncLoader(false);
                setShowValidationMessage(true);
                setSideIncAvailable(true);
            }
        });
    };

    const buttonDisable = () => {
        if (editOperation && newSideIncFullname.length === 0)
            return true;

        if (!editOperation)
            return (
                !showValidationMessage ||
                !sideIncAvailable ||
                newSideIncFullname.length === 0
            );

        return false;
    };

    return (
        <Box>
            <Modal
                backdrop="static"
                show={true}
                onHide={handleClose}
                enforceFocus={false}
            >

                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        {editOperation ? "Edit Side Inc" : "Add New Side Inc"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                {editOperation && (
                                    <tr>
                                        <td><Form.Label>Side Inc Id</Form.Label></td>
                                        <td><Form.Label>{sourceData.id}</Form.Label></td>
                                    </tr>
                                )}

                                <tr>
                                    <td><Form.Label>Side Inc <sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Side Inc (required)"
                                            placeholder="Side Inc"
                                            value={newSideInc}
                                            autoFocus
                                            disabled={editOperation}
                                            onBlur={(e) => validateSideIncPresent(newSideInc)}
                                            onChange={(e) => {
                                                setNewSideInc(e.target.value);
                                                setShowValidationMessage(false);
                                                setSideIncValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Side Inc Cannot be Empty");
                                            }}
                                            helperText={sideIncValidationError}
                                            error={sideIncValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {sideIncLoader ? (
                                            <CircularProgress size="1rem" />
                                        ) : !showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : sideIncAvailable ? (
                                            <font color="green">Side Inc available</font>
                                        ) : (
                                            <font color="red">Side Inc not available</font>
                                        )}
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Side Inc Fullname <sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Side Inc Fullname (required)"
                                            placeholder="Enter Side Inc Fullname"
                                            value={newSideIncFullname}
                                            onChange={(e) => {
                                                setNewSideIncFullname(e.target.value);
                                                setFullNameValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Side Inc Fullname Cannot be Empty");
                                            }}
                                            helperText={fullNameValidationError}
                                            error={fullNameValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Sequence</Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Sequence"
                                            placeholder="Enter Sequence"
                                            value={newSeq}
                                            onChange={(e) => setNewSeq(e.target.value)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loader}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={() => addEditSideInc()}
                        disabled={buttonDisable()}
                        sx={{ mr: 1 }}
                    >
                        Save
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        disabled={loader}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Box >
    )
}

export default AddSideIncModal;